type AutomaticRevenueRefreshInput = {
	filterColumn: string
	filterValue: string
}

type ApplyInvoiceFilterInput = AutomaticRevenueRefreshInput & {
	refreshRevenue: (userId: number) => Promise<unknown>
	applyFilter: () => void
}

export const getAutomaticRevenueRefreshUserId = ({
	filterColumn,
	filterValue,
}: AutomaticRevenueRefreshInput): number | null => {
	const normalizedFilterValue = filterValue.trim()

	if (filterColumn !== 'user_id' || !/^\d+$/.test(normalizedFilterValue)) {
		return null
	}

	const userId = Number(normalizedFilterValue)
	return Number.isSafeInteger(userId) && userId > 0 ? userId : null
}

export const applyInvoiceFilterWithAutomaticRevenueRefresh = async ({
	refreshRevenue,
	applyFilter,
	...refreshInput
}: ApplyInvoiceFilterInput) => {
	const refreshUserId = getAutomaticRevenueRefreshUserId(refreshInput)

	if (refreshUserId === null) {
		applyFilter()
		return
	}

	try {
		await refreshRevenue(refreshUserId)
	} finally {
		applyFilter()
	}
}
